<template>
    <section>
        <div class="month-box" v-for="(itemMonth, indexMonth) in monthList" :key="indexMonth">
            <h2>{{ itemMonth.month }} {{ itemMonth.year }}</h2>
            <div class="booking">
                <div class="row" v-if="itemMonth.appointmentList.length > 0">
                    <div class="col" v-for="(itemBooking, indexBooking) in itemMonth.appointmentList" :key="indexBooking">
                        <div class="board mb-4">
                            <div class="content" :class="{ 'service-done': itemBooking.bookingStatus === 'accept' }">
                                <div class="date">
                                    <label>วันที่</label>
                                    <span class="day">{{ itemBooking.bookingDate }}</span>
                                    <span class="weekday">{{ itemBooking.bookingWeekday }}</span>
                                </div>

                                <div class="time">
                                    <b-icon icon="clock"></b-icon> {{ itemBooking.bookingTime }} น.
                                </div>

                                <div class="data">
                                    <div class="item">
                                        <label><b-icon icon="calendar-range"></b-icon> วันที่สั่งจอง</label>
                                        <span>{{ itemBooking.createDate }}</span>
                                    </div>
                                    <div class="item">
                                        <label><b-icon icon="person"></b-icon> ชื่อลูกค้า</label>
                                        <span>{{ itemBooking.customerName }}</span>
                                    </div>
                                    <div class="item">
                                        <label><b-icon icon="telephone"></b-icon> เบอร์ติดต่อ</label>
                                        <span>{{ itemBooking.contactTel }}</span>
                                    </div>
                                    <div class="item">
                                        <label><b-icon icon="minecart-loaded"></b-icon> ทะเบียนรถ</label>
                                        <span>{{ itemBooking.licenseNumber }}</span>
                                    </div>
                                    <div class="item">
                                        <label><b-icon icon="box-seam"></b-icon> สถานะสต๊อค</label>
                                        <span class="stock done" v-if="itemBooking.bookingStatus === 'accept'">รับบริการแล้ว</span>
                                        <span class="stock no-stock" v-if="!itemBooking.bookingStatus && !itemBooking.stockStatus">ของไม่พอ</span>
                                        <span class="stock available" v-if="!itemBooking.bookingStatus &&itemBooking.stockStatus">มีของแล้ว</span>
                                    </div>
                                    <button class="btn btn-block btn-grey-outline" @click="openModalProductBooking(itemBooking, indexBooking, indexMonth)">ดูรายการสินค้าสั่งจอง</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="no-data" v-if="itemMonth.appointmentList.length === 0">
                    <b-icon icon="exclamation-diamond"></b-icon>
                    <span>ยังไม่มีรายการสั่งจองสินค้าในเดือนนี้</span>
                </div>
            </div>
        </div>

        <job-modal-product-booking
            :isDisplay="isShowModalProductBooking"
            :bookingData="selectedBooking.data"
            @reloadStockData="reloadStockData()"
            @hide="closeModalProductBooking()">
        </job-modal-product-booking>
    </section>
</template>

<script>
import moment from 'moment';
import DBBooking from '@/database/Booking';
import DBStock from '@/database/Stock';
import JobModalProductBooking from '@/components/job/schedule/ModalProductBooking';

export default {
    components: {
        JobModalProductBooking
    },
    data() {
        return {
            monthList: [],
            days: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
            stockBooking: [],
            selectedBooking: {
                indexBooking: -1,
                indexMonth: -1,
                data: null
            },
            isShowModalProductBooking: false
        }
    },
    async mounted() {
        this.loadMonthList();
        await this.loadBookingData();
    },
    methods: {
        openModalProductBooking(data, indexBooking, indexMonth) {
            this.isShowModalProductBooking = true;
            this.selectedBooking = {
                indexBooking: indexBooking,
                indexMonth: indexMonth,
                data: data
            };
        },
        closeModalProductBooking() {
            this.isShowModalProductBooking = false;
        },
        async reloadStockData() {
            this.stockBooking = [];
            this.loadMonthList();
            await this.loadBookingData();
            this.selectedBooking.data = this.monthList[this.selectedBooking.indexMonth].appointmentList[this.selectedBooking.indexBooking];
        },
        loadMonthList() {
            this.monthList = [];
            
            const totalMonth = 1;
            const currentDate = moment();

            for (let index = 0; index <= totalMonth; index++) {
                const outputDate = moment(currentDate).add(index, 'month');
                outputDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

                this.monthList.push({
                    year: outputDate.format('Y'),
                    month: outputDate.format('MMMM'),
                    moment: outputDate,
                    appointmentList: []
                });
            }
        },
        async loadBookingData() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            const result = await DBBooking.get();

            if (result.content && result.content.length > 0) {
                // Month Running
                for (const monthData of this.monthList) {
                    const calendarMonth = monthData.moment.format('M');
                    const calendarYear = monthData.moment.format('Y');

                    // Booking Running
                    for (const bookingData of result.content) {
                        const dateArray = this.getDateArray(bookingData.keyDate);
                        const bookingMonth = dateArray[1];
                        const bookingYear = dateArray[0];

                        if (calendarMonth === bookingMonth && calendarYear === bookingYear) {
                            // Appointment Running
                            for (const appointmentData of bookingData.appointment) {
                                if (appointmentData.reserve.product.length > 0) {
                                    const displayData = await this.mapAppointmentData(appointmentData);
                                    monthData.appointmentList.push(displayData);
                                }
                            }

                            monthData.appointmentList.sort((a, b)=> (a.appointmentDate > b.appointmentDate ? 1 : -1))
                        }
                    }
                }
            }

            loader.hide();
        },
        async mapAppointmentData(data) {
            const bookingMoment = moment(data.appointmentDate);

            await this.setupStockData(data.reserve);
            const productList = this.setupBookingStock(data.reserve);

            return {
                appointmentDate: data.appointmentDate,
                createDate: moment(data.timestamp).format('DD.MM.Y - HH:mm'),
                bookingDate: bookingMoment.format('D'),
                bookingWeekday: this.days[bookingMoment.format('D') % 7],
                bookingTime: data.appointmentTime,
                customerName: data.customerFirstName + ' ' + data.customerLastName,
                contactTel: data.customerTel,
                licenseNumber: data.licensePlate,
                bookingStatus: data.status,
                stockStatus: productList.findIndex(x => !x.stockStatus) > -1 ? false : true,
                stockList: productList
            };
        },
        getDateArray(keyDate) {
            return keyDate.split('-');
        },
        setupBookingStock(reserveList) {
            const productList = [];

            reserveList.product.forEach((item) => {
                // Booking Stock
                const index = this.stockBooking.findIndex(x => x.inventoryKey === item.inventoryKey);
                const data = this.stockBooking[index];

                // Add Product List
                productList.push({
                    inventoryKey: item.inventoryKey,
                    productData: item.productData,
                    quantity: item.quantity,
                    stockStatus: data.stockAvailable >= item.quantity
                });

                // Deduct Booking Stock
                data.stockAvailable -= item.quantity;
            });

            return productList;
        },
        async setupStockData(reserveList) {
            for (const item of reserveList.product) {
                if (!this.checkDataAvailableInStockBooking(item)) {
                    await this.addStockBookingList(item);
                }
            }
        },
        checkDataAvailableInStockBooking(item) {
            let isExist = false;

            if (this.stockBooking.length > 0) {
                isExist = this.stockBooking.findIndex(x => x.inventoryKey === item.inventoryKey) > -1;
            }

            return isExist;
        },
        async addStockBookingList(item) {
            this.stockBooking.push({
                inventoryKey: item.inventoryKey,
                productData: item.productData,
                stockAvailable: await this.getTotalStockByInventoryKey(item.inventoryKey)
            });
        },
        async getTotalStockByInventoryKey(key) {
            const stockData = await DBStock.getDetail(key);
            let totalStock = 0;

            if (stockData) {
                stockData.dots.forEach((item) => {
                    totalStock = totalStock + item.amountConsign + item.amountNormal + item.amountSublet;
                });
            }

            return totalStock;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.row {
    .col {
        flex: 0 0 33%;
        max-width: 33%;

        @media only screen and (max-width: $screenExtraLarge) {
            flex: 0 0 50%;
            max-width: 50%;
        }

        @media only screen and (max-width: $screenSmall) {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
}

.month-box {
    margin-bottom: 20px;
    border: 1px solid #3e3e3e;

    h2 {
        font-size: 22px;
        font-weight: bold;
        padding: 20px;
        text-align: center;
        background-color: $contentColor;
        color: $calendarMonthTextColor;
        margin: 0;
    }

    .booking {
        padding: 30px 30px 20px;
    }

    .content {
        position: relative;

        &.service-done {
            opacity: 0.75;
        }

        .date {
            position: absolute;
            top: -5px;
            right: 10px;
            background-color: #1a5b98;
            padding: 5px 10px;
            text-align: center;

            label {
                font-size: 12px;
                opacity: 0.75;
                display: block;
                margin: 0;
            }

            span {
                font-size: 12px;
                display: block;
                
                &.day {
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 20px;
                }

                &.weekday {
                    font-size: 10px;
                    opacity: 0.75;
                }
            }
        }

        .time {
            font-size: 13px;
            color: $textMainColor;
            
            &:after {
                content: " ";
                display: block;
                margin-top: 10px;
                width: 50px;
                height: 1px;
                background: rgba(255, 255, 255, 0.2);
            }

            .bi {
                margin-right: 5px;
            }
        }

        .data {
            font-size: 13px;
            margin-top: 20px;

            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 5px 0;

                label {
                    margin: 0;
                    opacity: 0.6;
                    
                    .bi {
                        margin-right: 5px;
                    }
                }

                span {
                    &.stock {
                        font-size: 11px;
                        padding: 2px 5px;

                        &.done {
                            background-color: #5e5f6f;
                        }

                        &.available {
                            background-color: #1e7b5d;
                        }

                        &.no-stock {
                            background-color: #cc0000;
                        }
                    }
                }
            }

            button {
                margin-top: 20px;
            }
        }
    }
}
</style>